module.exports = __webpack_public_path__ + "assets/img/loginbg.051431f5.png";